import { Component} from "@angular/core";
import { isPrescComGenerico, isPrescBancaPrivada, isPrescRentingAuto, isPrescUniversidades, isPrescDigital } from "../../constants/prescriptor-types.constants";
import { NgIf } from "@angular/common";

@Component({
    selector: "prescp-footer",
    templateUrl: "./footer.component.html",
    imports: [NgIf]
})
export class FooterComponent {
  mapfreText =
    ", accede a Service Manager utilizando la siguiente ruta: APLICACIONES > BANCASEGUROS > PRESCRIPCION SANTANDER, adjuntando la captura de pantalla con el error.";
  comercialesText =
    ", accede a ITSM, adjuntando la captura de pantalla con el error.";
  text: any;
  actuacion = sessionStorage.getItem("action");
  tipoPrescriptor = sessionStorage.getItem('tipoPresc');
  constructor() {}

  checkPrescComGenerico() {
    return isPrescComGenerico(this.tipoPrescriptor);
  }

  checkPrescBancaPrivada() {
    return isPrescBancaPrivada(this.tipoPrescriptor);
  }

  checkPrescRentingAuto() {
    return isPrescRentingAuto(this.tipoPrescriptor);
  }

  checkPrescUniversidades() {
    return isPrescUniversidades(this.tipoPrescriptor);
  }

  checkPrescDigital() {
    return isPrescDigital(this.tipoPrescriptor);
  }
}
